var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.items.length > 0)?_c('div',_vm._l((_vm.items),function(item){return _c('nuxt-link',{key:`CatalogFaq-${item._id}`,staticClass:"d-block mb-1",attrs:{"to":_vm.localePath({name: 'faq', hash: `#${item.slug}`})}},[_vm._v(" "+_vm._s(item.title)+" ")])}),1):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }